import { Box, Grid, Typography } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

const Detail = ({ label, value }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
    <Typography sx={{ fontWeight: 600, width: 100, fontSize: '16px' }}>
      {label}:
    </Typography>
    <Typography sx={{ fontSize: '16px' }}>{value}</Typography>
  </Box>
);

const PassengerInfo = ({ passengers, email }) => {
  return (
    <>
      {passengers?.map((passenger, index) => (
        <Box key={index}>
          {/* Cabecera del pasajero */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <PersonIcon fontSize="large" />
            <Typography
              sx={{
                ml: 1,
                color: '#000',
                fontWeight: 600,
                fontFamily: 'Open Sans',
                fontSize: '16px',
              }}
            >
              {`Pasajero ${index + 1}`}
            </Typography>
          </Box>

          {/* Separador */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mb: 1,
              mt: 1,
            }}
          >
            <Box
              sx={{
                height: '1px',
                width: '100%',
                bgcolor: '#000',
                mt: 1,
              }}
            />
          </Box>

          {/* Detalles del pasajero */}
          <Grid container spacing={2}>
            <Grid item xs={12} md={6} sx={{ py: { xs: 0, md: 'auto' } }}>
              <Detail label="Nombre" value={passenger.name} />
              <Detail label="Apellido" value={passenger.lastname} />
              {index === 0 && <Detail label="Email" value={email} />}
            </Grid>

            <Grid item xs={12} md={6} sx={{ py: { xs: 0, md: 'auto' } }}>
              <Detail label={passenger.typeDNI} value={passenger.dni} />
              {index === 0 && (
                <Detail
                  label="Teléfono"
                  value={`${passenger.caracteristicPhone} - ${passenger.phone}`}
                />
              )}
            </Grid>
          </Grid>
        </Box>
      ))}
    </>
  );
};

export default PassengerInfo;
